export const selectChosenMapTypes = state => state.map.chosen;